<template>
  <button
    class="primary-button w-full border-2 text-white py-1 md:py-2 px-4 rounded focus:outline-none"
    :class="[
      classes.indexOf('bg') < 0 && !(disabled || isLoading)
        ? 'bg-brand-green hover:bg-brand-dark-green'
        : '',
      classes,
      disabled || isLoading
        ? 'bg-brand-mid-gray border-brand-mid-gray hover:bg-brand-mid-gray cursor-not-allowed'
        : 'border-brand-green'
    ]"
    :disabled="disabled"
  >
    <template v-if="isLoading">
      <div class="py-2 md:py-1 flex justify-center">
        <SmallLoading mode="light" />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ""
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss"></style>
